import GLightbox from 'glightbox';

class Headless {
  constructor() {
    this.triggerEl = Array.from(document.querySelectorAll('[data-gallery]'));
    this.lightbox = undefined;
    this.currentSlideIndex = undefined;

    this.show = this.show.bind(this);

    this.addEventListeners();
    this.initLightbox();
  }

  addEventListeners() {
    this.triggerEl.forEach(el => el.addEventListener('click', this.show));
  }

  removeEventListeners() {
    this.triggerEl.forEach(el => el.removeEventListener('click', this.show));
  }

  initLightbox() {
    const arrayOfPromises = this.triggerEl.map(
      el => fetch(
        el.href + 'headless.content',
        {
          method: 'GET',
          headers: {
            'Content-Type': 'text/html;charset=utf-8'
          }
        }
      ).then(
        response => {
          if (!response.ok) {
            throw new Error(el.href + ' returned ' + response.statusText)
          }
          return response.text();
        }
      )
    );

    Promise.all(arrayOfPromises).then(contents => {
      this.lightbox = new GLightbox({
        elements: contents.map(content => ({ content: content })),
        selector: '[data-gallery]',
        openEffect: 'fade',
        closeEffect: 'fade',
        width: 1380,
        height: 840,
        zoomable: false,
        autoplayVideos: false
      });

      if (this.currentSlideIndex !== undefined) {
        this.lightbox.openAt(this.currentSlideIndex);
      }
    }).catch(() => {
      this.removeEventListeners();
    });
  }

  blockClicks(evt) {
    if (typeof evt !== 'undefined' && evt.currentTarget.hasAttribute('data-gallery')) {
      evt.preventDefault();
    }
  }

  show(evt) {
    this.blockClicks(evt);

    this.currentSlideIndex = this.triggerEl.indexOf(evt.currentTarget);

    if (this.lightbox !== undefined) {
      this.lightbox.openAt(this.currentSlideIndex);
    }
  }
}
export default new Headless();
